const CategorySkeleton = () => {
    return (
        <section className="px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8 my-10 overflow-hidden">
            <h2 className="text-sm lg:text-3xl font-semibold mb-8">
                <div className="bg-gray-200 animate-pulse h-6 w-3/4 rounded-md"></div>
            </h2>

            <div className="relative grid gap-5 sm:grid-cols-1 lg:grid-cols-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={index} className="bg-gray-200 animate-pulse rounded-md overflow-hidden">
                        <div className="h-32 bg-gray-300"></div>
                        <div className="p-4">
                            <div className="h-6 bg-gray-300 mb-2 w-3/4 rounded-md"></div>
                            <div className="h-4 bg-gray-300 rounded-md"></div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default CategorySkeleton;
